<template>
  <VaPopover trigger="hover" placement="bottom-end" stick-to-edges>
    <div class="flex flex-row items-center shrink truncate">
      <VaAvatar class="mr-2" :fallback-text="publisherDisplayName(publisherStore.currentPublisher).substring(0,1)" />
      <span class="truncate">
        {{ publisherDisplayName(publisherStore.currentPublisher) }}
      </span>
    </div>

    <template #body>
      <p class="px-4 pt-3 pb-1 text-sm text-gray-600 text-center">{{ t('publishers.switch') }}</p>
      <VaMenuList>
        <VaMenuItem
          v-for="publisher in publisherStore.publishers"
          :key="publisher.id"
          class="w-full pointer"
          @click="publisherStore.switchPublisher(publisher.id)"
        >
          {{ publisherDisplayName(publisher) }}
        </VaMenuItem>
      </VaMenuList>

      <div class="p-4 flex flex-col gap-2 text-center">
        <VaButton preset="secondary" :to="{ name: 'publisher.settings' }">
          {{ t('menu.settings') }}
        </VaButton>
        <VaButton :to="{ name: 'publisher.create' }">
          {{ t('publishers.createTitle') }}
        </VaButton>
      </div>
    </template>
  </VaPopover>
</template>

<script lang="ts" setup>
import { VaAvatar, VaButton, VaMenuItem, VaMenuList, VaPopover } from 'vuestic-ui'
import { usePublisherStore } from '@/stores/PublisherStore'
import { publisherDisplayName } from '@/models/Publisher'
import { useI18n } from 'vue-i18n'

const publisherStore = usePublisherStore()
const { t } = useI18n()
</script>
